import logoBataljong from "../assets/images/bataljong-logo.png";
import logoEu from "../assets/images/eu-logo.png";
import translate from "../locales";

export function Footer({ gemeente, logoGemeente }) {
  return (
    <footer className="page__footer">
      <div className="footer__links">
        <div className="footer__left">
          {logoGemeente && (
            <img
              src={logoGemeente}
              alt={translate(gemeente + "_gemeente_logo_alt")}
              className="footer__logo footer__logo--gemeente"
            />
          )}
          <img
            src={logoBataljong}
            alt={translate("bataljong_logo_alt")}
            className="footer__logo footer__logo--bataljong"
          />
          <img
            src={logoEu}
            alt={translate("eu_logo_alt")}
            className="footer__logo footer__logo--eu"
          />
        </div>
        <div className="footer__right">
          <a
            href="https://bataljong.be/privacy-policy"
            target="_blank"
            rel="noreferrer"
          >
            {translate("privacy")}
          </a>
          <svg
            width="4"
            height="4"
            viewBox="0 0 4 4"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="1.65613" cy="1.65613" r="1.65613" fill="black" />
          </svg>
          {translate("made_by")}: Tree company
        </div>
      </div>
    </footer>
  );
}
